var map = {
	"./": [
		"74M3",
		3,
		13
	],
	"./en/privacy/remember-and-eject.md": [
		"3QQZ",
		9,
		60
	],
	"./en/privacy/tor.md": [
		"wOoM",
		9,
		61
	],
	"./en/security/passphrase.md": [
		"UJ4v",
		9,
		62
	],
	"./en/security/pin.md": [
		"ZKJG",
		9,
		63
	],
	"./en/security/shamir-backup.md": [
		"f7HE",
		9,
		64
	],
	"./en/security/single-backup.md": [
		"6upo",
		9,
		65
	],
	"./en/suite-basics/accounts.md": [
		"S6vl",
		9,
		66
	],
	"./en/suite-basics/buy-sell-and-trade.md": [
		"L8Iv",
		9,
		67
	],
	"./en/suite-basics/labeling.md": [
		"//U5",
		9,
		68
	],
	"./en/suite-basics/receive.md": [
		"6Y8e",
		9,
		69
	],
	"./en/suite-basics/send/import.md": [
		"dZh4",
		9,
		70
	],
	"./en/suite-basics/send/locktime.md": [
		"0vnm",
		9,
		71
	],
	"./en/suite-basics/send/op_return.md": [
		"5z4p",
		9,
		72
	],
	"./en/suite-basics/send/rbf-replace-by-fee.md": [
		"n2pN",
		9,
		73
	],
	"./en/suite-basics/send/send-raw.md": [
		"JYOG",
		9,
		74
	],
	"./en/suite-basics/send/send.md": [
		"w1bH",
		9,
		75
	],
	"./en/suite-basics/send/transaction-fees.md": [
		"VYPj",
		9,
		76
	],
	"./en/suite-basics/suite-guide.md": [
		"LFTt",
		9,
		77
	],
	"./en/supported-crypto-assets/custom-eth-token.md": [
		"C6Mh",
		9,
		78
	],
	"./en/supported-crypto-assets/eth-tokens.md": [
		"SUR9",
		9,
		79
	],
	"./en/supported-crypto-assets/supported-coins.md": [
		"HIEm",
		9,
		80
	],
	"./index": [
		"74M3",
		3,
		13
	],
	"./index.json": [
		"74M3",
		3,
		13
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[2]).then(function() {
		return __webpack_require__.t(id, ids[1])
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "Pqd6";
module.exports = webpackAsyncContext;